import React from 'react';
import * as _ from 'lodash';
import { checkSelectedAll } from '../../../utilities/commonUtil';
import { GATE_PASSAGES_STATUS_CODE } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

/**
 * 種別の複数選択 ドロップダウン
 *
 * @export
 * @class GatePassagesStatusDropdown
 * @extends {React.Component}
 */
export class GatePassagesStatusDropdown extends React.Component {
  constructor(props) {
    super(props);

    let options = {};
    _.map(GATE_PASSAGES_STATUS_CODE, statusCode => {
      if (statusCode.id > 0) {
        options[statusCode.id] = statusCode;
      }
    });

    this.state = {
      opened: false,
      selected: [],
      options,
      error: '',
      selectedName: '',
      selectAll: false,
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.isSelected = this.isSelected.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.resetSelected = this.resetSelected.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.refreshed) {
      this.setState({
        selected: nextProps.value,
        selectedName: nextProps.name || '',
        selectAll: false,
      });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }

    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.resetSelected();
  };

  /**
   * 値を変更前に戻す
   */
  resetSelected() {
    const state = this.state;
    state.opened = false;
    this.setState(state);
  }

  handleOpen = () => {
    const state = this.state;
    // 初期化
    if (!this.state.opened) {
      state.opened = true;
      state.selectAll = checkSelectedAll(state.selected, _.map(state.options, 'id'));
      this.setState(state);
    } else {
      this.resetSelected();
    }
  };

  handleSelectedRow = (id, checked) => {
    let selected = _.compact(this.state.selected);
    if (checked) {
      selected.push(parseInt(id));
    } else {
      selected = _.pull(selected, id);
    }
    const selectAll = checkSelectedAll(selected, _.map(this.state.options, 'id'));
    this.setState({ selected, selectAll }, () => {
      this.setValue();
    });
  };

  setValue = () => {
    this.props.set('status_code', this.state.selected);
  };

  // -----------------------------------------------------------

  handleSelectedAll = () => {
    const selectedAll = this.state.selectAll;
    let selected = [];
    if (!selectedAll) {
      _.each(this.state.options, gate => {
        selected.push(parseInt(gate.id));
      });
    }
    const state = this.state;
    state.selectAll = !selectedAll;
    state.selected = selected;

    this.setState(state, () => {
      this.setValue();
    });
  };

  isSelected(gateId) {
    let bool = false;
    if (_.indexOf(this.state.selected, gateId) !== -1) {
      bool = true;
    }
    return bool;
  }

  render() {
    return (
      <div className='form-element__element'>
        <div id='form-dropdown' className='dropdown-multi-select' ref={this.parent}>
          <div className='dropdown-multi-select__header'>
            <div
              id='form-dropdown-btn'
              href=''
              className='dropdown-select'
              onClick={() => this.handleOpen()}
            >
              <span className='dropdown-select__txt'>
                {_.isEmpty(this.state.selected)
                  ? '未選択'
                  : _.join(_.map(
                      this.state.selected,
                      (selected) => this.state.options[selected].name
                    ),
                    ',',
                  )
                }
              </span>
            </div>
          </div>
          <div
            id='form-dropdown-list'
            className={
              this.state.opened
                ? 'dropdown dropdown--dropdown-multi-select show'
                : 'dropdown dropdown--dropdown-multi-select'
            }
          >
            <div className='dropdown__item'>
              <div className='dropdown-multi-select__item'>
                <div className='dropdown-multi-select__checkall'>
                  <div className='btn-checkbox'>
                    <label
                      htmlFor={`checkall-gate-passages-statusCode-${this.id}`}
                    >
                      <input
                        id={`checkall-gate-passages-statusCode-${this.id}`}
                        type='checkbox'
                        checked={this.state.selectAll}
                        onChange={this.handleSelectedAll}
                      />
                      <i className='i-square-checkbox i-2_5x' />
                    </label>
                  </div>
                  {/* ラベルクリックでラジオボタン選択のため(全選択) */}
                  <label
                    htmlFor={`checkall-gate-passages-statusCode-${this.id}`}
                  >
                    {messageUtility.getMessage('I-000-092')}
                  </label>
                </div>
              </div>
              <div className='dropdown-multi-select__scroll' id={this.targetId}>
                <ul id='dropdown-multi-select-list' className='multi-select'>
                  {_.map(this.state.options, (option, index) => (
                    <SelectableOption
                      key={index}
                      option={option}
                      checked={this.isSelected(option.id)}
                      targetId={this.id}
                      handleSelectedRow={this.handleSelectedRow}
                    />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='multi-select__item'>
    <div className='checkbox'>
      <label
        htmlFor={`multi-select-gate-passages-statusCode-${
          option.id
        }-${targetId}`}
      >
        <input
          id={`multi-select-gate-passages-statusCode-${option.id}-${targetId}`}
          type='checkbox'
          checked={checked}
          onClick={() => handleSelectedRow(option.id, !checked)}
        />
        <i className='i-square-checkbox i-2_5x' />
      </label>
    </div>
    <div
      className='multi-select__label'
      onClick={() => handleSelectedRow(option.id, !checked)}
    >
      {option.name}
    </div>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/GatePassagesStatus.jsx